import React from 'react';
import estiloServicios from './Servicios.module.css';
import ListaServicios from '../components/ListaServicios';
import WhatsappFloatButton from '../components/WhatsappFloatButton';

import serv1 from '../assets/servicios/ReabilitacionOral.webp';
import serv2 from '../assets/servicios/Endodoncia.webp';
import serv3 from '../assets/servicios/Ortodoncia.webp';
import serv4 from '../assets/servicios/Implantologia.webp';
import serv5 from '../assets/servicios/Periodoncia.webp';
import serv6 from '../assets/servicios/CirugiaOral.webp';
import serv7 from '../assets/servicios/RadiologiaOral.webp';
import serv8 from '../assets/servicios/Coronas.webp';
import serv9 from '../assets/servicios/ProtesisParcial.webp';
import serv10 from '../assets/servicios/ProtesisTotal.webp';


function Servicios() {

    const serviciosData = [
        {
            id: 1,
            titulo: 'Rehabilitación Oral',
            descripcion: 'Estimado paciente, si ha tenido varios problemas dentales que afectan tanto su estética como su función masticatoria, la rehabilitación oral es una excelente opción. Este tratamiento integral está diseñado para restaurar completamente su boca, devolviéndole tanto la funcionalidad como la belleza de su sonrisa. A través de soluciones como implantes, coronas, prótesis y puentes, podemos devolverle la confianza al mejorar su capacidad para masticar, hablar y sonreír sin problemas. Si busca una solución a largo plazo para restaurar su salud dental, este es el camino ideal.',
            imagen: serv1,
        },
        {
            id: 2,
            titulo: 'Endodoncia',
            descripcion: '¿Está experimentando dolor o sensibilidad intensa al morder? Es posible que su diente tenga una infección en la pulpa, lo que puede requerir un tratamiento de conductos. La endodoncia le ayudará a salvar su diente, eliminando la infección y restaurando la salud de su diente afectado. Este procedimiento no solo alivia el dolor, sino que también previene la extracción del diente. De esta manera, lograremos que su diente siga funcionando de manera natural, y usted podrá disfrutar de una sonrisa libre de molestias.',
            imagen: serv2,
        },
        {
            id: 3,
            titulo: 'Ortodoncia',
            descripcion: 'Si sus dientes están desalineados o tiene problemas con la mordida, la ortodoncia es la solución perfecta para usted. Con el uso de brackets o alineadores invisibles, podemos corregir la posición de sus dientes y mandíbula, mejorando tanto la estética como la funcionalidad de su sonrisa. El tratamiento no solo hace que sus dientes se vean más bonitos, sino que también mejora su salud dental, facilitando una correcta higiene y evitando problemas de desgaste dental. ¡No espere más para lograr la sonrisa que siempre ha deseado!',
            imagen: serv3,
        },
        {
            id: 4,
            titulo: 'Implantología Oral',
            descripcion: 'La pérdida de dientes no tiene por qué ser permanente. Los implantes dentales son una solución moderna y efectiva para reemplazar dientes perdidos. A través de un procedimiento quirúrgico mínimamente invasivo, colocamos un implante de titanio que actúa como una raíz artificial, proporcionando una base sólida para una corona, puente o dentadura. Los resultados son naturales, duraderos y estéticamente agradables, devolviendo la funcionalidad completa de su boca. Si está buscando una opción permanente para restaurar su sonrisa, los implantes dentales son una excelente opción.',
            imagen: serv4,
        },
        {
            id: 5,
            titulo: 'Periodoncia',
            descripcion: 'Las encías son la base de sus dientes, y su salud es fundamental. Si ha notado encías inflamadas, sangrantes o dolorosas, podría estar experimentando una enfermedad periodontal. Tratamos desde casos leves hasta más complejos con soluciones como limpiezas profundas, cirugía periodontal y tratamiento para las encías. Si se detecta a tiempo, podemos evitar que los problemas en las encías afecten la salud de sus dientes. ¡Cuidar de sus encías es el primer paso hacia una boca sana!',
            imagen: serv5,
        },
        {
            id: 6,
            titulo: 'Cirugía Oral',
            descripcion: 'En algunos casos, pueden ser necesarios procedimientos quirúrgicos para resolver problemas dentales complejos, como la extracción de dientes impactados, quistes o lesiones en la boca. Nuestra cirugía oral se realiza de forma segura y controlada, siempre bajo anestesia local o sedación para que esté cómodo y tranquilo. Nos aseguramos de que el proceso sea lo menos invasivo posible, y le ofrecemos seguimiento para asegurar que su recuperación sea rápida y sin complicaciones.',
            imagen: serv6,
        },
        {
            id: 7,
            titulo: 'Radiología Oral',
            descripcion: 'La radiografía es una herramienta fundamental para diagnosticar y tratar problemas dentales. A través de nuestras radiografías digitales, podemos obtener imágenes claras y precisas de su boca, dientes y encías, ayudándonos a identificar problemas que no se pueden ver a simple vista, como caries, infecciones o dientes impactados. Es una forma rápida, segura y eficaz de planificar su tratamiento, asegurándonos de que recibas el mejor cuidado posible.',
            imagen: serv7,
        },
        {
            id: 8,
            titulo: 'Coronas y Puentes',
            descripcion: 'Si ha perdido un diente o tiene un diente dañado, las coronas y los puentes son la opción ideal para restaurar la estética y funcionalidad de su boca. Las coronas cubren el diente dañado, devolviendo su forma y resistencia, mientras que los puentes reemplazan los dientes ausentes al anclarse en los dientes adyacentes. Ambos procedimientos están diseñados para durar muchos años, restaurando su sonrisa de forma natural y eficiente.',
            imagen: serv8,
        },
        {
            id: 9,
            titulo: 'Prótesis Parcial',
            descripcion: 'Cuando falta uno o varios dientes, una prótesis parcial puede ser la solución perfecta. Se trata de una dentadura removible que reemplaza los dientes faltantes, ayudando a restablecer la funcionalidad de la boca, mejorar la estética y evitar que los dientes restantes se desalineen. Las prótesis parciales se adaptan de manera cómoda y natural a su boca, permitiéndole comer y hablar sin problemas.',
            imagen: serv9,
        },
        {
            id: 10,
            titulo: 'Prótesis Total',
            descripcion: 'Si ha perdido todos sus dientes, las prótesis totales ofrecen una solución eficaz y económica. Estas dentaduras completas se colocan sobre las encías y le permiten recuperar la capacidad de masticar, hablar y sonreír con naturalidad. Son totalmente personalizadas para ajustarse a sus necesidades y le garantizan una sonrisa completa. Si está buscando una solución para reemplazar todos sus dientes, las prótesis totales le ofrecerán una alternativa cómoda y funcional.',
            imagen: serv10,
        },

    ];

    return (

        <>
            <div className={estiloServicios.fondo}>

                <div>
                    <ListaServicios servicios={serviciosData} />
                </div>

                <WhatsappFloatButton />
            </div>

        </>
    );
}

export default Servicios;